// B14: тест заголовков и описаний страниц личностей для поиска.
// Группа A получает вариант 1, группа B вариант 2, остальные страницы (группа C и все прочие) остаются
// с прежним шаблоном. Список и тексты должны совпадать с person.html.twig в frontend_for_searchbots:
// заголовок в оболочке приложения и в странице для ботов обязан быть одним и тем же.
// После замера (14 дней после выкладки) файл удаляется или шаблон выкатывается на все страницы.
const VARIANT_BY_SLUG = {
    // группа A, вариант 1
    tomhardi: 1,
    nastyakamenskikh: 1,
    dima_maslennikov: 1,
    michael_fassbender: 1,
    monicabellucci: 1,
    al_pacino: 1,
    dmitriy_kuplinov: 1,
    milosh_bikovich: 1,
    viggo_mortensen: 1,
    dmitrykomarov: 1,
    // группа B, вариант 2
    irinastarshenbaum: 2,
    aglayashilovskaya: 2,
    andrey_mironov: 2,
    marinafedunkiv: 2,
    alexanderustyugov: 2,
    timothee_chalamet: 2,
    brianmaps: 2,
    liam_neeson: 2,
    alena_shishkova: 2,
    evgeniyaloza: 2,
};

const MAX_TITLE = 60;
const MAX_DESCRIPTION = 155;

// Первый вариант из списка, который влезает в лимит. Длинное имя получает более короткую формулировку,
// а не обрезанный посреди слова заголовок
const fit = (candidates, limit) =>
    candidates.find((text) => text.length <= limit) || candidates[candidates.length - 1];

// Имя подставляется в начальной форме, склонения нет (решение маркетолога: если шаблон не склоняет,
// оставить как есть). Род влияет только на «него» и «неё»
export function titleTestMeta(slug, name, gender) {
    const variant = VARIANT_BY_SLUG[slug];
    if (!variant || !name) {
        return null;
    }
    const him = gender === "F" ? "неё" : "него";

    if (variant === 1) {
        return {
            title: fit(
                [
                    `${name}: характер, тип личности и совместимость с вами`,
                    `${name}: характер и совместимость с вами`,
                    `${name}: характер и совместимость`,
                ],
                MAX_TITLE
            ),
            description: fit(
                [
                    `Разбор характера ${name}: сильные стороны, тип мышления, лучшие профессии. Узнайте, насколько вы на ${him} похожи и совпадаете.`,
                    `Разбор характера ${name}: сильные стороны, тип мышления, лучшие профессии.`,
                ],
                MAX_DESCRIPTION
            ),
        };
    }

    return {
        title: fit(
            [
                `${name} и вы: на кого похожи и насколько совместимы`,
                `${name} и вы: на кого похожи`,
                `${name}: на кого вы похожи`,
            ],
            MAX_TITLE
        ),
        description: fit(
            [
                `Загрузите фото или пройдите тест и узнайте, насколько вы похожи на ${name} по характеру. Подробный разбор личности на странице.`,
                `Узнайте, насколько вы похожи на ${name} по характеру. Подробный разбор личности на странице.`,
            ],
            MAX_DESCRIPTION
        ),
    };
}
